<ng-template #infoDialog class="modal fade" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true">
  <div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="closeDialog()">
          <span aria-hidden="true">&times;</span>
        </button>
  </div>
  <div class="modal-body">
    <ng-content></ng-content>
  </div>
</ng-template>